const footerNav = [
  {
    title: "下载安装",
    links: [
      { label: "手机版安装步骤", href: "#mobile" },
      { label: "TV 版安装说明", href: "#tv" },
      { label: "版本更新日志", href: "#versions" },
      { label: "设备适配清单", href: "#devices" },
    ],
  },
  {
    title: "使用帮助",
    links: [
      { label: "平台亮点介绍", href: "#features" },
      { label: "使用技巧", href: "#tips" },
      { label: "常见问题解答", href: "#faq" },
      { label: "安全提示", href: "#safety" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="w-full bg-accent-900 text-background-100">
      <div className="w-full px-4 md:px-8 pt-14 pb-8">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2 max-w-sm">
            <div className="flex items-center gap-2">
              <span className="w-9 h-9 rounded-lg bg-background-50 text-accent-900 flex items-center justify-center">
                <i className="ri-movie-2-line text-lg"></i>
              </span>
              <span className="font-heading text-lg font-bold text-background-50">星辰影视</span>
            </div>
            <p className="mt-4 text-sm text-background-100/80 leading-relaxed">
              星辰影视客户端与 app 下载页面，提供手机版、tv 版安装包获取方式与清晰安装步骤，
              帮助你在各种设备上快速完成安装并开始观影。
            </p>
            <p className="mt-4 text-xs text-background-100/60 leading-relaxed">
              本页仅用于介绍客户端下载与安装方法，安装包信息以页面展示为准。
            </p>
          </div>

          {footerNav.map((group) => (
            <div key={group.title}>
              <h3 className="font-heading text-sm font-bold text-background-50 tracking-wide">
                {group.title}
              </h3>
              <ul className="mt-4 flex flex-col gap-3">
                {group.links.map((link) => (
                  <li key={link.label}>
                    <a
                      href={link.href}
                      className="text-sm text-background-100/75 hover:text-background-50 cursor-pointer transition-colors"
                    >
                      {link.label}
                    </a>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="max-w-6xl mx-auto mt-12 pt-6 border-t border-background-50/15 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-100/60">
            © 2026 星辰影视. 保留所有权利.
          </p>
          <a
            href="#top"
            className="text-xs text-background-100/75 hover:text-background-50 cursor-pointer inline-flex items-center gap-1.5"
          >
            <i className="ri-arrow-up-line"></i>
            返回顶部
          </a>
        </div>
      </div>
    </footer>
  );
}